import { SpriteIconButton, SpriteIconButtonProps } from 'ui/components/sprite-icon-button';

import { forwardRef } from 'react';

export type IconButtonProps = Omit<SpriteIconButtonProps, 'path'>;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(props, ref) {
  return <SpriteIconButton path='/sprites/spritesheet.svg' {...props} ref={ref} />;
});
